<div class="flex flex-col h-full w-[16rem] bg-[var(--thalea-sidebar)] border-1 border-[var(--sabbia-400)] pt-5 gap-1">
  <div class="flex flex-col gap-2 mb-2 mt-2 pl-4 w-full justify-center">
    <img src="logo-thalea.svg" class="w-20.5" />
  </div>
  <div class="flex flex-col gap-4 flex-1 p-2 overflow-y-auto scrollbar-hide">
    <div class="flex flex-col gap-1">
      @for (item of sidebarItemsService.firstItems(); track $index) {
        <thalea-sidebar-item [item]="item"></thalea-sidebar-item>
      }
    </div>
    @if (sidebarItemsService.servicesItems().length > 0) {
      <div class="flex flex-col gap-1">
        <p class="p-2 font-medium color-[#3F3F46] text-xs">Servizi</p>
        @for (item of sidebarItemsService.servicesItems(); track $index) {
          <thalea-sidebar-item [item]="item"></thalea-sidebar-item>
        }
      </div>
    }
    <div class="mt-auto flex flex-col gap-1">
      @for (item of sidebarItemsService.bottomItems(); track $index) {
        <thalea-sidebar-item
          [item]="item"
          (itemClick)="handleBottomItemClick($event)"
        ></thalea-sidebar-item>
      }
    </div>
  </div>
</div>
